<template>
  <div class="content">
    <div class="page-inner">
      <!-- <div class="page-header">
        <ul class="breadcrumbs">
          <li class="nav-item">
            <router-link to="/artists">
              {{ $t('artists') }}
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link :to="`/artists/${artist.key}`" v-if="artist._id">{{ artist.name }}</router-link>
          </li>
        </ul>
      </div> -->

      <h4 class="page-title">{{ $t('artist_website') }}</h4>

      <div class="row">
        <div class="col-md-12" v-if="artists.length">
          <div class="card">
            <div class="card-body p-2">
              <div class="form-group">
                <label for="">{{ $t('artist') }}:</label>
                <select class="form-control" v-model="currentArtist" @change="changeArtist()">
                  <option :value="artist._id" v-for="artist in artists" v-bind:key="`artist_${artist._id}`">{{ artist.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title" v-if="artist._id">{{ $t('preview') }}:</div>
              <div class="card-category">
                <a :href="`https://indiefy.me/${artist.key}`" rel="ugc noopener noreferrer" target="_blank">https://indiefy.me/{{artist.key}}</a>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $t('general_information') }}
              </div>
              <div class="card-body">
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Spotify</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <input type="url" class="form-control" :value="artist.spotify" readonly="readonly" placeholder="https://" aria-label="website" name="website">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Instagram</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="instagram-addon">@</span>
                      </div>
                      <input type="text" v-model="artist.instagram" class="form-control" placeholder="" aria-label="instagram" aria-describedby="instagram-addon" name="instagram">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Twitter</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="twitter-addon">@</span>
                      </div>
                      <input type="text" class="form-control" v-model="artist.twitter" placeholder="" aria-label="twitter" aria-describedby="twitter-addon" name="twitter">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">Facebook Page</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="username-addon">facebook.com/</span>
                      </div>
                      <input type="text" v-model="artist.facebook" class="form-control" placeholder="" aria-label="first_name" aria-describedby="username-addon" name="first_name">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('youtube_channel') }} <span class="badge badge-primary ml-1">PRO</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <input :disabled="!user.subscription" type="url" class="form-control" v-model="artist.youtube" placeholder="https://www.youtube.com/@agnosticmusic" aria-label="youtube_video" name="youtube_video">
                    </div>
                  </div>
                </div>
                <div class="form-group form-show-validation row">
                  <label for="birth" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('bio') }}</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <textarea class="form-control" v-model="artist.bio"></textarea>
                  </div>
                </div>
                <!-- <div class="form-group form-show-validation row">
                  <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">{{ $t('youtube_video') }} <span class="badge badge-primary ml-1">PRO</span></label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <div class="input-group">
                      <input :disabled="!user.subscription" type="url" class="form-control" v-model="artist.youtube_video" placeholder="https://youtube.com/watch?v=BNqVvd7sK6g" aria-label="youtube_video" name="youtube_video">
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="card-action text-right">
                <router-link :to="`/artists/${artist.key}`" class="btn btn-default btn-border no-border mr-1">
                  <i class="fa fa-chevron-left mr-1"></i> {{ $t('back') }}
                </router-link>
                <button class="btn btn-gradient" @click="saveArtist()" type="button" :disabled="saving">
                  {{ $t('save') }}
                </button>
              </div>
            </div>
          </div>

          <!-- <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $t('main_photos') }}
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 text-center mb-2 pos-relative">
                    <img :src="artist.main_image_1 || defaultImage" class="img-thumbnail mr-1" width="475" height="300" style="width: 475px; height: 300px;">
                    <input type="file" class="hide" accept=".jpg, .jpeg" @change="uploadImage($event, 'main_image_1', 1900, 1200)">
                    <button type="button" class="btn btn-default gallery-upload-btn" onclick="$(this).prev().click()" v-if="!artist.main_image_1">
                      <i class="fa fa-upload"></i>
                    </button>
                    <button type="button" class="btn btn-danger gallery-remove-btn" @click="removeImage('main_image_1')" v-if="artist.main_image_1">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="col-md-6 text-center mb-2 pos-relative">
                    <img :src="artist.main_image_1 || defaultImage" class="img-thumbnail mr-1" width="475" height="300" style="width: 475px; height: 300px;">
                    <input type="file" class="hide" accept=".jpg, .jpeg" @change="uploadImage($event, 'main_image_2', 1900, 1200)">
                    <button type="button" class="btn btn-default gallery-upload-btn" onclick="$(this).prev().click()" v-if="!artist.main_image_1">
                      <i class="fa fa-upload"></i>
                    </button>
                    <button type="button" class="btn btn-danger gallery-remove-btn" @click="removeImage('main_image_2')" v-if="artist.main_image_1">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $t('image_gallery') }}
              </div>
              <div class="card-body p-0">
                <div class="row mt-2">
                  <div class="col-md-4 pos-relative" v-for="(photo, index) in artist.photos" v-bind:key="`photo_${index}`">
                    <img :src="photo || defaultImage" class="img-thumbnail mb-1">
                    <button type="button" class="btn btn-danger gallery-remove-btn" @click="removeImage('photos', index)">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="col-md-4" v-if="!artist.photos || artist.photos.length < 6">
                    <div class="pos-relative" style="height: 250px; width: 250px">
                      <img :src="defaultImage" class="img-thumbnail mb-1" style="width: 250px; height: 250px;">
                      <input type="file" class="hide" accept=".jpg, .jpeg" @change="uploadImage($event, 'photos')">
                      <button type="button" class="btn btn-default gallery2-upload-btn" onclick="$(this).prev().click()">
                        <i class="fa fa-upload"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Artists from '../services/artists'
import Select2 from './utils/Select2'
import Upload from '../services/upload'
import _ from 'underscore'

export default {
  name: 'PublicPage',
  data: function () {
    return {
      user: {},
      saving: false,
      defaultImage: '/static/img/gray-bg.jpg',
      artists: [],
      currentArtist: null,
      artist: {
        spotify_id: '',
        name: '',
        main_genre: ''
      }
    }
  },
  methods: {
    changeArtist: function () {
      this.artist = _.find(this.artists, artist => artist._id === this.currentArtist)
    },
    saveArtist: function () {
      Artists.save(this.artist).then(() => {
        this.$notify({ message: this.$t('artist_updated') }, 'success', 'fa-check')
      })
    },
    checkImageSize (file, width, height) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const _URL = window.URL || window.webkitURL || window.mozURL || window.msURL

        img.onload = function () {
          if (this.width === width && this.height === height) {
            resolve()
          } else {
            // eslint-disable-next-line
            reject()
          }
        }

        if (width && height) {
          img.src = _URL.createObjectURL(file)
        } else {
          resolve()
        }
      })
    },
    removeImage (imageName, index) {
      if (imageName === 'photos') {
        if (!this.artist.photos[index]) {
          this.artist.photos.splice(index, 1)
        } else {
          Upload.removeImage(this.artist.photos[index].split('/').pop(), 'gallery-images')
          this.artist.photos.splice(index, 1)
        }
      } else {
        Upload.removeImage(this.artist[imageName].split('/').pop(), 'gallery-images')
        this.artist[imageName] = ''
      }

      Artists.save(this.artist).then(() => {
        this.$notify({ message: this.$t('image_removed') }, 'success', 'fa-check')
      })
    },
    uploadImage: function (event, imageName, width, height) {
      let file = event.target.files[0]

      this.checkImageSize(file, width, height).then(() => {
        let fileName = `${this.artist._id}_${imageName}_${new Date().getTime()}.${file.name.split('.').pop()}`

        Upload.uploadImage(file, 'artist-images', fileName).then(response => {
          if (!this.artist.photos) {
            this.artist.photos = []
          }

          if (imageName === 'photos') {
            if (!this.artist.photos) {
              this.artist.photos = []
            }

            this.artist.photos.push(response.data.full)
          } else {
            this.artist[imageName] = response.data.full
          }

          Artists.save(this.artist).then(() => {
            this.$notify({ message: this.$t('image_uploaded') }, 'success', 'fa-check')
          })
        })
      }).catch(() => {
        this.$notify({ message: this.$t('invalid_image_size') }, 'warning', 'fa-exclamation')
      })
    }
  },
  created: function () {
    this.user = this.$user

    if (this.$route.params.id) {
      Artists.get(this.$route.params.id).then(response => {
        this.artist = response.data
        this.currentArtist = this.artist._id
      })
    } else {
      Artists.getAll().then(response => {
        this.artists = response.data

        if (this.artists[0]) {
          this.artist = this.artists[0]
          this.currentArtist = this.artist._id
        }
      })
    }
  },
  mounted: function () {

  },
  components: {
    Select2
  }
}
</script>
<style lang="scss" scoped>
#artist-image {
  width: 200px;
  height: 200px;
  border-radius: 3px;
}

.hide {
  display: none;
}

.gallery-upload-btn {
  position: absolute;
  top: 41%;
  left: 45%;
}

.gallery-remove-btn {
  position: absolute;
  right: -3px;
  top: -3px;
}

.gallery2-upload-btn {
  position: absolute;
  top: 41%;
  left: 38%;
}
</style>



// WEBPACK FOOTER //
// src/components/PublicPage.vue